import type { IconProps } from '../types'

const ErrorAlert = ({ width = '36px', height = '36px' }: IconProps) =>
  <svg role='figure' width={width} height={height} viewBox="0 0 36 36">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <g>
          {/* eslint-disable-next-line max-len */}
          <path d="M18,0 C8.064,0 0,8.064 0,18 C0,27.936 8.064,36 18,36 C27.936,36 36,27.936 36,18 C36,8.064 27.936,0 18,0 Z" fill="#FFFFFF" />
          {/* eslint-disable-next-line max-len */}
          <path d="M18,6 C11.376,6 6,11.376 6,18 C6,24.624 11.376,30 18,30 C24.624,30 30,24.624 30,18 C30,11.376 24.624,6 18,6 Z" stroke="#CC6900" />
          {/* eslint-disable-next-line max-len */}
          <path d="M25.5,9.5 L9.23654403,25.763456" stroke="#CC6900" strokeWidth="1.25" strokeLinecap="square" />
        </g>
      </g>
    </g>
  </svg>

export { ErrorAlert }
